import Alert from 'kepler/lib/components/Alert'

export default Alert
